import { UrlTree } from '@angular/router';
// angular
import { Inject, Injectable, Optional } from '@angular/core';
import { ActivatedRouteSnapshot, Route, RouterStateSnapshot } from '@angular/router';
import { RESPONSE } from 'src/express.tokens';
import { Response } from 'express';
@Injectable()
export class UserServerGuard  {
  constructor(
    @Optional() @Inject(RESPONSE) private res: Response,
  ){
    if(this.res) {
        this.res.statusCode = 403;
      }
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return false;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return false;
  }

  canLoad(route: Route): boolean | UrlTree {   
   return false;
  }
}
